<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import ButtonGroup from 'dashboard/components-next/buttonGroup/ButtonGroup.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
const route = useRoute();

const { uiSettings, updateUISettings } = useUISettings();

const isConversationRoute = computed(() => {
  const CONVERSATION_ROUTES = [
    'inbox_conversation',
    'conversation_through_inbox',
    'conversations_through_label',
    'team_conversations_through_label',
    'conversations_through_folders',
    'conversation_through_mentions',
    'conversation_through_unattended',
    'conversation_through_unread',
    'conversation_through_participating',
    'inbox_view_conversation',
    // Internal team chat has its own bottom-right composer/send button — the
    // launcher would overlap it, so hide it here too.
    'internal_chat_index',
    // Central de Ajuda embutida renderiza o portal em iframe, que já tem o
    // próprio widget "pedir ajuda" no canto inferior — o launcher do Copilot
    // sobreporia, então esconde nesta rota também.
    'help_center_view',
  ];
  return CONVERSATION_ROUTES.includes(route.name);
});

const currentAccountId = useMapGetter('getCurrentAccountId');
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

const showCopilotLauncher = computed(() => {
  const isCaptainEnabled = isFeatureEnabledonAccount.value(
    currentAccountId.value,
    FEATURE_FLAGS.CAPTAIN_V2
  );
  return (
    isCaptainEnabled &&
    !uiSettings.value.is_copilot_panel_open &&
    !isConversationRoute.value
  );
});
const toggleSidebar = () => {
  updateUISettings({
    is_copilot_panel_open: !uiSettings.value.is_copilot_panel_open,
    is_contact_sidebar_open: false,
  });
};
</script>

<template>
  <div
    v-if="showCopilotLauncher"
    class="fixed bottom-4 ltr:right-4 rtl:left-4 z-50"
    data-ai-tour="copilot-launcher"
  >
    <ButtonGroup
      class="rounded-full bg-n-brand/90 backdrop-blur-lg p-1 shadow-lg hover:shadow-xl transition-shadow ai-launcher-pulse"
    >
      <Button
        icon="i-woot-captain"
        no-animation
        class="!rounded-full !bg-n-brand !text-white text-xl transition-all duration-200 ease-out hover:!bg-n-brand-hover"
        lg
        data-testid="copilot-launcher"
        @click="toggleSidebar"
      />
    </ButtonGroup>
  </div>
  <template v-else />
</template>
